export default __webpack_public_path__ + "static/12-c7538a49d87033722ad934430978fa7b.png";